import Api from '@/services/api.js';

export default {
  addRate(details) {
    return Api.post('rates/', details);
  },
  getAllRates() {
    return Api.get('rates/');
  },
  deleteRate(rate) {
    return Api.delete(`rates/${rate}`);
  },
  updateRate(rate) {
    var rateId = rate.id;
    return Api.put(`rates/${rateId}`, rate);
  },

  getRates(payload) {
    return Api.get(`rates/${payload.projectId}/${payload.showClosed}`)
  },
  getRatesById(id, type) {
    if (type == 'project') {
      return this.getRatesByProject(id)
    } else {
      return this.getRatesBySite(id)
    }
  },
  getRatesByProject(id) {
    return Api.get('rates/byProject/' + id);
  },
  getRatesBySite(id) {
    return Api.get('rates/bySite/' + id);
  },
  getRateById(rate) {
    return Api.get(`rates/${rate}`)
  },
  getAuditsByRate(rate) {
    return Api.get(`rates/audits/${rate}`)
  },
  getRateByParams(params) {
    return Api.post(`rates/byParams`, params)
  }

}
